import FormikInput from 'components/formikFields/input'
import Header from 'components/headers/wallet'
import { Form, Formik } from 'formik'
import AliceCarousel from 'react-alice-carousel'
import 'react-alice-carousel/lib/alice-carousel.css'
import { BankConvertor } from 'utilities/helper/banksConvertor'
import {
    verifyCardNumber,
    getBankNameFromCardNumber,
    getShebaInfo,
} from '@persian-tools/persian-tools'
import useSetAddCard from './hooks/useSetAddCard'
import { toast } from 'react-toastify'
import { useState } from 'react'
import CustomBottomSheet from 'components/bottomSheet'
import { BankNameConvertor } from 'utilities/helper/bankNameConvertor'
import DotsLoading from 'components/loadings/dotsLoading'
import StarIcon from 'assets/images/star/star.svg'
import useSetVerifiedCard from './hooks/useSetVerifiedCard'
import classNames from 'classnames'
import { Schema } from './utils'

export default function AddBankCard() {
    const [isOpen, setIsOpen] = useState<boolean>(false)
    const [isIban, setIsIban] = useState<boolean>(false)
    const banks: Array<string> = Object.values(BankConvertor)
    const { mutate, data, isLoading } = useSetAddCard(setIsOpen)
    const { mutateVerify } = useSetVerifiedCard()
    return (
        <div>
            <Formik
                initialValues={{ card_number: '' }}
                onSubmit={async (values) => {
                    if (!isIban) {
                        if (verifyCardNumber(Number(values.card_number))) {
                            mutate({
                                cardNumber: values.card_number,
                                isIban,
                            })
                        } else {
                            toast.error('اطلاعات کارت وارد شده درست نیست')
                        }
                    } else {
                        if (getShebaInfo(`IR${values.card_number}`)) {
                            mutate({
                                cardNumber: 'IR' + values.card_number,
                                isIban,
                            })
                        } else {
                            toast.error('اطلاعات کارت وارد شده درست نیست')
                        }
                    }
                }}
            >
                {({ values }) => (
                    <Form className="h-screen flex flex-col">
                        <>
                            <div className=" grow-0">
                                <Header title="مدیریت کارت‌های بانکی" />
                            </div>
                            <div className="grow mt-8">
                                <p className=" text-green-1 text-center mx-3 text-sm mt-4">
                                    شما می‌توانید با افزودن شماره‌ کارت یا شبای
                                    خود، حساب خود را در همیان ثبت کنید
                                </p>
                                <div className=" flex justify-center mt-6">
                                    <div className=" w-[40%] bg-gray-bg rounded-full text-center items-center flex justify-between">
                                        <p
                                            className={classNames(
                                                '  px-4 py-3 rounded-full',
                                                !isIban &&
                                                    'bg-green-1 w-full text-white'
                                            )}
                                            onClick={() => {
                                                setIsIban(false)
                                                values.card_number = ''
                                            }}
                                        >
                                            کارت
                                        </p>
                                        <p
                                            className={classNames(
                                                '  px-4 py-3 rounded-full',
                                                isIban &&
                                                    'bg-green-1 w-full text-white'
                                            )}
                                            onClick={() => {
                                                setIsIban(true)
                                                values.card_number = ''
                                            }}
                                        >
                                            شبا
                                        </p>
                                    </div>
                                </div>
                                <div className=" mx-3 mt-6 text-sm font-normal">
                                    <div dir="ltr">
                                        <FormikInput
                                            type="number"
                                            label={
                                                !isIban ? 'شماره کارت' : 'شبا'
                                            }
                                            name="card_number"
                                            className="text-sm font-normal"
                                            isIban={isIban}
                                            min={0}
                                        />
                                    </div>
                                    <p className=" text-sm text-green-1 mt-2">
                                        {!isIban
                                            ? getBankNameFromCardNumber(
                                                  values.card_number
                                              )
                                            : getShebaInfo(
                                                  `IR${values.card_number}`
                                              )?.persianName}
                                    </p>
                                </div>
                            </div>
                            <div className=" w-full flex justify-center grow">
                                <div className=" w-[50%]">
                                    <p className=" text-sm text-center">
                                        بانک‌های تحت پوشش همیان
                                    </p>
                                    <AliceCarousel
                                        mouseTracking
                                        autoPlay
                                        autoPlayInterval={2800}
                                        disableDotsControls
                                        keyboardNavigation={false}
                                        infinite
                                        autoWidth
                                        items={banks.map((item) => (
                                            <img
                                                src={item}
                                                alt=""
                                                onDragStart={(e) =>
                                                    e.preventDefault()
                                                }
                                                role="presentation"
                                                className=" w-10 h-10"
                                            />
                                        ))}
                                    />
                                </div>
                            </div>
                            <button className=" grow-0 text-white  rounded-lg bg-green-1 mb-2 py-3 mx-2">
                                ثبت کارت
                            </button>
                        </>
                    </Form>
                )}
            </Formik>
            <CustomBottomSheet
                isOpen={isOpen}
                onDismiss={() => setIsOpen(false)}
            >
                <>
                    <div className=" flex w-full justify-center">
                        <p className=" text-center text-sm">تایید کارت</p>
                    </div>
                    <hr className=" my-3" />
                    <p className=" text-sm text-center mb-3">
                        آیا اطلاعات زیر را تایید می‌کنید؟
                    </p>
                    {!isLoading && data ? (
                        <>
                            <div className="shadow-[rgba(0,_0,_0,_0.24)_0px_3px_8px] bg-gradient-to-b from-from-card to-to-card mx-3 my-3 rounded-xl px-4 py-2">
                                <div className=" flex justify-between mb-2 mt-3">
                                    <img
                                        src={
                                            BankNameConvertor[
                                                data.bank_unique_code
                                            ]
                                        }
                                        alt="bank"
                                    />
                                    {data.is_default && (
                                        <img src={StarIcon} alt="star" />
                                    )}
                                </div>
                                <div className=" my-4 text-xl text-center text-black">
                                    <p dir="ltr">
                                        {!isIban
                                            ? data.card_number
                                                  .match(/.{1,4}/g)
                                                  ?.join('\xa0\xa0\xa0\xa0')
                                            : data.iban
                                                  .match(/.{1,4}/g)
                                                  ?.join('\xa0\xa0\xa0\xa0')}
                                    </p>
                                </div>
                                <div className=" mb-2 flex justify-between">
                                    <p>{data.full_name}</p>
                                </div>
                            </div>
                            <div className=" w-full flex justify-between">
                                <button
                                    className=" w-full bg-green-1 rounded-md text-white py-2 mx-2 "
                                    onClick={() => mutateVerify(data?.id)}
                                >
                                    تایید
                                </button>
                                <button
                                    className=" w-full text-green-1  border-1 border-green-1 rounded-md py-2 mx-2"
                                    onClick={() => setIsOpen(false)}
                                >
                                    ویرایش
                                </button>
                            </div>
                        </>
                    ) : (
                        <DotsLoading />
                    )}
                </>
            </CustomBottomSheet>
        </div>
    )
}
